import { makeAutoObservable } from "mobx";

export class Manufacturer {
    Id: number;
    Name: string;
    IsActive: boolean;
    constructor() {
        makeAutoObservable(this);
        this.Id = 0;
        this.Name = null;
        this.IsActive = false;
    }
}